import { Box, Stack } from "@mui/material";
import { useTranslation } from "next-i18next";
import { TIconComponent } from "src/components/icons-mui/icon-component.types";
import { IconMotiveBuyingTheDip } from "src/components/icons-mui/motive-buying-the-dip";
import { IconMotiveFearOfMissingOut } from "src/components/icons-mui/motive-fear-of-missing-out";
import { IconMotiveJumpingTheShip } from "src/components/icons-mui/motive-jumping-the-ship";
import { IconMotiveTakingProfits } from "src/components/icons-mui/motive-taking-profits";
import { SimpleRichText } from "src/components-mui/common/rich-text/simple-rich-text";
import {
    UNDERLYING_LIST_MOTIVE_CONFIG,
    UnderlyingListMotive,
    getUnderlyingListMotiveColor,
} from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.constants";

const MOTIVE_ICONS: Record<UnderlyingListMotive, TIconComponent> = {
    [UnderlyingListMotive.TakingProfits]: IconMotiveTakingProfits,
    [UnderlyingListMotive.FearOfMissingOut]: IconMotiveFearOfMissingOut,
    [UnderlyingListMotive.JumpingTheShip]: IconMotiveJumpingTheShip,
    [UnderlyingListMotive.BuyingTheDip]: IconMotiveBuyingTheDip,
};

interface IListMotiveDescriptionProps {
    motive: UnderlyingListMotive;
    dataTestId?: string;
}

export const ListMotiveDescription = ({ motive, dataTestId }: IListMotiveDescriptionProps) => {
    const { t } = useTranslation("underlying-overview");
    const { titleKey, tradeDirection, priceTrend } = UNDERLYING_LIST_MOTIVE_CONFIG[motive];
    const color = getUnderlyingListMotiveColor(motive);
    const MotiveIcon = MOTIVE_ICONS[motive];

    return (
        <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
            <Box
                sx={{
                    display: "flex",
                    flexShrink: 0,
                    alignItems: "center",
                    justifyContent: "center",
                    width: "71px",
                    height: "54px",
                    borderRadius: "2px",
                    backgroundColor: `${color}.100`,
                }}
            >
                <MotiveIcon aria-hidden sx={{ fontSize: "48px", color: `${color}.500` }} />
            </Box>
            <SimpleRichText
                fontSize={["sm", "md"]}
                text={t("trading-motives.description", {
                    0: t(titleKey),
                    1: t(`trading-motives.to-${tradeDirection}`),
                    2: t(`trading-motives.${priceTrend}`),
                })}
                data-test-id={dataTestId}
            />
        </Stack>
    );
};
